import { FC } from 'react'
import payreadyLogo from 'src/assets/images/payready_logo_cobalt.svg'
import { StyledPayreadyLogo } from '../GlobalFooter/GlobalFooter.styles'
import {
  ContentContainer,
  ErrorMessage,
  ErrorTitle,
  StyledButton,
  Wrapper,
} from './PayReady.styles'
import { useDomain } from 'src/contexts/providers/DomainProvider'

interface Props {
  buttonText?: string
  buttonOnClick: () => void
  error?: Error
}

const PayReadyError: FC<Props> = ({ error, buttonText, buttonOnClick }) => {
  const errorMessage = typeof error === 'string' ? error : error?.message
  const { isPayReady } = useDomain()
  return (
    <Wrapper>
      <ContentContainer>
        <ErrorTitle>Something Went Wrong</ErrorTitle>
        <ErrorMessage>
          {errorMessage ?? 'The action you tried could not be completed.'}
        </ErrorMessage>
        {isPayReady && (
          <>
            <StyledButton variant="contained" fullWidth onClick={buttonOnClick}>
              {buttonText ?? 'Go Back'}
            </StyledButton>
            <StyledPayreadyLogo src={payreadyLogo} alt="PayReady Logo" />
          </>
        )}
      </ContentContainer>
    </Wrapper>
  )
}

export default PayReadyError
